import { cn } from '@distribute/frontend/utils';
import { FC, HTMLAttributes, PropsWithChildren } from 'react';

type Props = HTMLAttributes<HTMLTableRowElement> & {
  className?: string;
  onClick?: () => void;
};

export const TableRow: FC<PropsWithChildren<Props>> = ({
  children,
  className,
  onClick,
  ...props
}) => {
  return (
    <tr
      {...props}
      className={cn(
        'rounded-xl cursor-pointer h-14 text-sm text-gray-700 hover:shadow-sm [&:has(.table-action:hover)]:shadow-none',
        className
      )}
      onClick={onClick}
    >
      {children}
    </tr>
  );
};
